import { useEffect, useState } from "react";

const useCurrentIp = () => {
  const [currentIp, setCurrentIp] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getIp = async () => {
      try {
        const res = await fetch("https://api.ipify.org/?format=json");
        const data = await res.json();

        setCurrentIp(data.ip);
      } catch {
        setCurrentIp("No detectada");
      } finally {
        setLoading(false);
      }
    };

    getIp();
  }, []);

  return {
    currentIp,
    loading,
  };
};

export default useCurrentIp;
